import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//MUI Components
import { Autocomplete, TextField } from '@mui/material';

//Utilities
import { obtenerUbicacionNivel1 } from './UbicacionesFunctions';

export const SelectUbicacionNivel1 = ({ textLabel, textSinOpciones, testSeleccione, setIdElemento, idElemento = '00000000-0000-0000-0000-000000000000',  idElementoPadre = '', sesionUsuario, dispatch }) => {

    const [elemento, setElemento] = React.useState({ locLocationId: '00000000-0000-0000-0000-000000000000', locName: '' });
    const [listadoElementos, setListadoElementos] = useState([]);

    const LoadProperties = async () => {
        await obtenerUbicacionNivel1(idElementoPadre, setListadoElementos, sesionUsuario, dispatch);
        setListadoElementos(current => [{ locLocationId: '00000000-0000-0000-0000-000000000000', locName: testSeleccione }, ...current]);
    };

    useEffect(() => {
        LoadProperties();
    }, [idElementoPadre]);

    useEffect(() => {
        if (idElemento !== '00000000-0000-0000-0000-000000000000') {
            if (listadoElementos.length > 0) {
                if (Enumerable.from(listadoElementos).any(x => x.locLocationId.toLowerCase() === idElemento.toLowerCase())) {
                    setElemento({ locLocationId: idElemento, locName: Enumerable.from(listadoElementos).first(x => x.locLocationId.toLowerCase() === idElemento.toLowerCase()).locName });
                } else {
                    setElemento({ locLocationId: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
                }
            } else {
                setElemento({ locLocationId: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
            }
        } else {
            setElemento({ locLocationId: '00000000-0000-0000-0000-000000000000', locName: testSeleccione });
        }
    }, [idElemento]);

    useEffect(() => {
        setIdElemento(elemento === null || elemento === undefined ? '00000000-0000-0000-0000-000000000000' : elemento.locLocationId);
    }, [elemento?.locLocationId]);

    const ingresarValoresMemoriaAuto = (event, newValue) => {
        setElemento(newValue);
    };

    return (
        <Autocomplete fullWidth
            disabled={listadoElementos.length === 1}
            noOptionsText={textSinOpciones}
            value={elemento}
            id={textLabel}
            name='UbicacionNivel1-Element'
            options={listadoElementos}
            onChange={ingresarValoresMemoriaAuto}
            getOptionLabel={(option) => option.locName}
            getOptionDisabled={(option) => option.locLocationId === '00000000-0000-0000-0000-000000000000'}
            renderInput={(params) => <TextField name='label' {...params} label={textLabel} />}
        />
    )
}